export default class ViewBalance {
    constructor() {
        this.lastNameValidationMsg = document.getElementById("lastNameValidationMsg");
        this.memberNumberValidationMsg = document.getElementById("memberNumberValidationMsg");
        this.spinner = document.getElementById("viewBalanceSpinner");
        this.pointsSpan = document.getElementById("gmRewardsPoints");
        this.banner = document.getElementById("gmRewardsBanner");
        this.resultBanner = document.getElementById("gmRewardsBannerResult");
        this.notFoundMemberErrorMessage = document.getElementById("notFoundMemberErrorMessage");
        this.errorMessage = document.getElementById("errorMessageDesktop");
        this.sharedDataDesktop = document.getElementById("sharedDataTextDesktop");
        this.sharedDataMobile = document.getElementById("sharedDataTextMobile");
        this.mobileMediaQuery = globalThis.matchMedia("(max-width: 768px)");
        this.isMobile = this.mobileMediaQuery.matches;
        // Listen for changes in screen size
        this.mobileMediaQuery.addEventListener("change", (e) => {
            this.isMobile = e.matches;
            this.updateSharedDataVisibility();
        });
        const formElement = document.querySelector(".viewBalanceForm");
        if (formElement instanceof HTMLFormElement) {
            this.form = formElement;
            this.form.addEventListener("submit", (e) => this.onSubmit(e));
            this.lastNameInput = this.form.querySelector(`[name="LastName"]`);
            this.lastNameInput.addEventListener("input", () => this.onLastNameInput());
            this.memberNumberInput = this.form.querySelector(`[name="MemberNumber"]`);
            this.memberNumberInput.addEventListener("input", (e) => this.onMemberNumberInput(e));
        }
        else {
            this.form = null;
        }
    }
    updateSharedDataVisibility() {
        if (!this.isValid()) {
            this.hideAll();
            return;
        }
        if (this.errorMessage?.style.display === "block") {
            this.hideAll();
            return;
        }
        if (this.notFoundMemberErrorMessage?.style.display === "block") {
            this.hideAll();
            return;
        }
        this.isMobile ? this.showMobileOnly() : this.showDesktopOnly();
    }
    onLastNameInput() {
        if (this.errorMessage?.style.display === "block")
            return;
        if (this.notFoundMemberErrorMessage?.style.display === "block")
            return;
        if (!this.lastNameIsValid())
            return;
        this.clearInputErrors("lastName");
        const memberNumberShowingAsValid = this.memberNumberValidationMsg?.style.display === "none";
        if (memberNumberShowingAsValid && this.isMobile) {
            if (this.sharedDataMobile)
                this.sharedDataMobile.style.display = "block";
        }
        else if (memberNumberShowingAsValid) {
            if (this.sharedDataDesktop)
                this.sharedDataDesktop.style.display = "block";
        }
    }
    onMemberNumberInput(e) {
        this.applyMemberNumberMask(e);
        if (this.errorMessage?.style.display === "block")
            return;
        if (this.notFoundMemberErrorMessage?.style.display === "block")
            return;
        if (!this.memberNumberIsValid())
            return;
        this.clearInputErrors("memberNumber");
        const lastNameShowingAsValid = this.lastNameValidationMsg?.style.display === "none";
        if (lastNameShowingAsValid && this.isMobile) {
            if (this.sharedDataMobile)
                this.sharedDataMobile.style.display = "block";
        }
        else if (lastNameShowingAsValid) {
            if (this.sharedDataDesktop)
                this.sharedDataDesktop.style.display = "block";
        }
    }
    applyMemberNumberMask(e) {
        const rawValue = this.memberNumberInput.value;
        const caret = this.memberNumberInput.selectionStart ?? rawValue.length;
        const cleanValue = rawValue.trim().replace(/[-\s]/g, "");
        const maskedValue = cleanValue.length > 1
            ? `${cleanValue.slice(0, 1)}-${cleanValue.slice(1)}`
            : cleanValue;
        this.memberNumberInput.value = maskedValue;
        // keep caret in place when hyphen or whitespace is entered
        let newCaret = caret;
        if (e.data?.trim().length === 0) {
            newCaret = caret - e.data.length;
        }
        else if (caret === 2 && e.inputType === "insertText") {
            newCaret++;
        }
        this.memberNumberInput.setSelectionRange(newCaret, newCaret);
    }
    async onSubmit(event) {
        event.preventDefault();
        if (!this.form)
            return;
        this.resetFormStyles();
        if (!this.validate()) {
            if (this.sharedDataDesktop)
                this.sharedDataDesktop.style.display = "none";
            if (this.sharedDataMobile)
                this.sharedDataMobile.style.display = "none";
            return;
        }
        this.showSpinner();
        const memberNumber = this.memberNumberInput.value.trim();
        const lastName = this.lastNameInput.value.trim();
        const url = `/api/oemssaa/gm/rewards/${encodeURIComponent(memberNumber)}/${encodeURIComponent(lastName)}/points`;
        try {
            const response = await fetch(url, {
                method: "GET",
                headers: { Accept: "application/json" },
            });
            this.hideSpinner();
            await this.handleResponse(response);
        }
        catch (err) {
            this.hideSpinner();
            console.error("Error submitting GM Balance form:", err);
            this.handleGenericError();
        }
    }
    async handleResponse(response) {
        if (response.ok) {
            await this.handleSuccess(response);
            // Form Submission DoTagging
            this.formSubmissionDoTagging();
        }
        else if (response.status === 404) {
            this.handleNotFound();
        }
        else {
            this.handleGenericError();
        }
    }
    async handleSuccess(response) {
        const data = await response.json();
        if (this.pointsSpan) {
            this.pointsSpan.textContent = data.totalPoints?.toLocaleString() ?? "0";
        }
        if (this.banner)
            this.banner.style.display = "none";
        if (this.resultBanner)
            this.resultBanner.style.display = "block";
    }
    handleNotFound() {
        this.showErrorStyles(this.notFoundMemberErrorMessage);
    }
    handleGenericError() {
        this.showErrorStyles(this.errorMessage);
    }
    /** ------
     * Helpers
     * ------- */
    isValid() {
        return this.lastNameIsValid() && this.memberNumberIsValid();
    }
    hideAll() {
        this.setDisplay("none", this.sharedDataMobile);
        this.setDisplay("none", this.sharedDataDesktop);
    }
    showMobileOnly() {
        this.setDisplay("block", this.sharedDataMobile);
        this.setDisplay("none", this.sharedDataDesktop);
    }
    showDesktopOnly() {
        this.setDisplay("block", this.sharedDataDesktop);
        this.setDisplay("none", this.sharedDataMobile);
    }
    setDisplay(value, element) {
        if (element) {
            element.style.display = value;
        }
    }
    showSpinner() {
        if (this.spinner)
            this.spinner.style.display = "";
    }
    hideSpinner() {
        if (this.spinner)
            this.spinner.style.display = "none";
    }
    resetFormStyles() {
        if (!this.form)
            return;
        const wrappers = this.form.querySelectorAll(".input-wrapper");
        wrappers.forEach((wrapper) => {
            wrapper.classList.remove("input-error");
            const icon = wrapper.querySelector(".error-icon");
            if (icon instanceof HTMLImageElement) {
                icon.style.display = "none";
            }
        });
        const inputs = this.form.querySelectorAll(".form-group input");
        inputs.forEach((i) => {
            i.style.border = "";
            i.style.color = "";
        });
        if (this.errorMessage)
            this.errorMessage.style.display = "none";
        if (this.notFoundMemberErrorMessage)
            this.notFoundMemberErrorMessage.style.display = "none";
        if (this.sharedDataDesktop)
            this.sharedDataDesktop.style.display = "";
    }
    showErrorStyles(errorMessageElement) {
        if (!this.form)
            return;
        const wrappers = this.form.querySelectorAll(".input-wrapper");
        wrappers.forEach((wrapper) => {
            wrapper.classList.add("input-error");
            const icon = wrapper.querySelector(".error-icon");
            if (icon instanceof HTMLImageElement) {
                icon.style.display = "block";
            }
        });
        const inputs = this.form.querySelectorAll(".form-group input");
        inputs.forEach((input) => {
            input.style.border = "2px solid #B60000";
            input.style.color = "#B60000";
        });
        if (this.sharedDataDesktop)
            this.sharedDataDesktop.style.display = "none";
        if (this.sharedDataMobile)
            this.sharedDataMobile.style.display = "none";
        if (errorMessageElement)
            errorMessageElement.style.display = "block";
    }
    validate() {
        if (!this.form)
            return false;
        const lastNameValid = this.lastNameIsValid();
        if (!lastNameValid) {
            this.showInputErrors("lastName");
        }
        const memberNumberValid = this.memberNumberIsValid();
        if (!memberNumberValid) {
            this.showInputErrors("memberNumber");
        }
        return lastNameValid && memberNumberValid;
    }
    lastNameIsValid() {
        const lastName = this.lastNameInput.value.trim();
        return lastName.length >= 2 && lastName.length <= 40;
    }
    memberNumberIsValid() {
        const memberNumber = this.memberNumberInput.value.trim();
        return memberNumber.length > 1 && memberNumber[1] === "-";
    }
    showInputErrors(inputName) {
        document.getElementById(`${inputName}ValidationMsg`).style.display =
            "block";
        const wrapperSelector = `#${inputName}InputWrapper`;
        const wrapper = this.form.querySelector(wrapperSelector);
        wrapper.classList.add("input-error");
        const icon = wrapper.querySelector(".error-icon");
        if (icon instanceof HTMLImageElement) {
            icon.style.display = "block";
        }
        const inputSelector = `#${inputName}`;
        const input = this.form.querySelector(inputSelector);
        input.style.border = "2px solid #B60000";
        input.style.color = "#B60000";
    }
    clearInputErrors(inputName) {
        document.getElementById(`${inputName}ValidationMsg`).style.display = "none";
        const wrapperSelector = `#${inputName}InputWrapper`;
        const wrapper = this.form.querySelector(wrapperSelector);
        wrapper.classList.remove("input-error");
        const icon = wrapper.querySelector(".error-icon");
        if (icon instanceof HTMLImageElement) {
            icon.style.display = "none";
        }
        const inputSelector = `#${inputName}`;
        const input = this.form.querySelector(inputSelector);
        input.style.border = "";
        input.style.color = "";
    }
    formSubmissionDoTagging() {
        const taggingData = {
            event: "lead_submitted",
            page_type: "home",
            card_name: "GM Rewards Points Balance",
            event_owner: "dealeron",
            comm_type: "form",
            comm_outcome: "not_opportunity",
            department: "unknown",
            event_action_result: "complete",
            event_action: "click",
            product_name: "GM Rewards Homepage Banner",
            element_text: "View Balance*",
            form_name: "GM Rewards",
            form_type: "custom",
            submission_id: "-2",
        };
        globalThis.dispatchEvent(new CustomEvent("dotagging.event", {
            bubbles: true,
            detail: {
                data: taggingData,
            },
        }));
    }
}
globalThis.DoUtility.SelfInstantiateOnLoad(ViewBalance);
